import {
  MessagesSquare,
  House,
  LayoutDashboard,
  Waypoints,
  Rss,
  Shield,
  FileText,
} from "lucide-react";

const isDD = process.env.REACT_APP_IS_DD === "true";
const isII = process.env.REACT_APP_IS_II === "true";
const isCP = process.env.REACT_APP_IS_CP === "true";
const isAB = process.env.REACT_APP_IS_AB === "true";

const CURRENT_INSTANCE = isDD
  ? "DD"
  : isII
    ? "II"
    : isCP
      ? "CP"
      : isAB
        ? "AB"
        : null;

const isRouteEnabledForCurrentInstance = (enabledFor) => {
  if (!CURRENT_INSTANCE) return false;

  return enabledFor.includes(CURRENT_INSTANCE);
};

const SECTION_DEFS_BASE = [
  {
    path: "/home",
    label: "Home",
    Icon: House,
    hasSubItems: false,
    enabledFor: ["DD", "II", "CP", "AB"],
  },
  {
    path: "/chat",
    label: "Chat",
    Icon: MessagesSquare,
    hasSubItems: true,
    enabledFor: ["DD", "II", "CP", "AB"],
  },
  {
    path: "/wiki",
    label: "Wiki",
    Icon: LayoutDashboard,
    hasSubItems: CURRENT_INSTANCE === "CP",
    enabledFor: ["DD", "CP"],
  },
  {
    path: "/graph",
    label: "Graph",
    Icon: Waypoints,
    hasSubItems: true,
    enabledFor: ["DD", "II", "CP", "AB"],
  },
  {
    path: "/apts",
    label: "APTs",
    Icon: Shield,
    hasSubItems: false,
    enabledFor: ["CP"],
  },
  {
    path: "/reports",
    label: "Reports",
    Icon: FileText,
    hasSubItems: true,
    enabledFor: ["DD", "II", "CP", "AB"],
  },
  {
    path: "/feed",
    label: "Feed",
    Icon: Rss,
    hasSubItems: true,
    enabledFor: ["DD", "II", "CP", "AB"],
  },
];

export const SECTION_DEFS = SECTION_DEFS_BASE.filter((section) =>
  isRouteEnabledForCurrentInstance(section.enabledFor),
);

export const SIDEBAR_SECTIONS = SECTION_DEFS.map((section) => ({
  path: section.path,
  label: section.label,
  icon: <section.Icon strokeWidth={1} />,
  hasSubItems: section.hasSubItems,
}));

if (process.env.NODE_ENV === "development" && !CURRENT_INSTANCE) {
  console.warn(
    "No app instance configured. Expected one of REACT_APP_IS_DD, REACT_APP_IS_II, REACT_APP_IS_CP, or REACT_APP_IS_AB to be true.",
  );
}
